import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
// import UserMessagePageGrid from "../../common/Messaging/UserMessageGridLayout";

const Messaging = ({userId}) => {
  return (
    <div style={{width: "1000vh", height: "1000vh"}}>
      {/* <UserMessagePageGrid userId={userId}/> */}
    </div>
  );
};

export default Messaging;
